export const ATHENA_URL = 'https://athena.comma.ai'
export const API_URL = 'https://api.comma.ai'
export const BILLING_URL = 'https://billing.comma.ai'
export const USERADMIN_URL = 'https://useradmin.comma.ai'
